var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9654 5.81523L8.36536 11.4319C8.2987 11.4986 8.22648 11.5457 8.1487 11.5732C8.07092 11.6012 7.98759 11.6152 7.8987 11.6152C7.80981 11.6152 7.72648 11.6012 7.6487 11.5732C7.57092 11.5457 7.4987 11.4986 7.43203 11.4319L1.81536 5.81523C1.65981 5.65968 1.58203 5.46523 1.58203 5.2319C1.58203 4.99857 1.66536 4.79857 1.83203 4.6319C1.9987 4.46524 2.19314 4.3819 2.41536 4.3819C2.63759 4.3819 2.83203 4.46524 2.9987 4.6319L7.8987 9.5319L12.7987 4.6319C12.9543 4.47635 13.1458 4.39857 13.3734 4.39857C13.6014 4.39857 13.7987 4.4819 13.9654 4.64857C14.132 4.81523 14.2154 5.00968 14.2154 5.2319C14.2154 5.45412 14.132 5.64857 13.9654 5.81523Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.5520c5613b5001b8874c0cdef7b09ba3.svg";
export { ForwardRef as ReactComponent };